import styled from 'styled-components';

import { TooltipWrapper, TooltipContainer } from '@spa/shared/components/Tooltip/styles';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${props => props.theme.space(2)};
  margin-bottom: ${props => props.theme.space(2)};
  overflow: hidden;
  flex-wrap: wrap;
  height: 20px;

  ${TooltipWrapper} {
    ${TooltipContainer} {
      background: ${props => props.theme.backgrounds.shuttleGray};
      color: ${props => props.theme.typography.inverted};

      &:after,
      &:before {
        display: none;
      }
    }

    &:not(:last-of-type) {
      margin-right: ${props => props.theme.space(2.5)};
    }

    span {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: IntervalNextReg, sans-serif;
      font-weight: 400;
      line-height: 17px;
      font-size: ${props => props.theme.rem(14)};
    }
  }

  svg {
    height: 20px;
  }
`;
